import { parse } from './urlHelpers';

// Mirror of AUTH_LINK_STASH_PREFIX in server/authLinkHead.js: that head script
// moves the credentials of an emailed account link (reset or verification
// token, email) out of the address bar — tags report the URL to Google and
// Meta — and stashes them under the page's path segment.
const AUTH_LINK_STASH_PREFIX = 'auth_link_';
const AUTH_LINK_PARAMS = ['t', 'e'];
const AUTH_LINK_PATH = /^(?:\/[a-z]{2})?\/(reset-password|verify-email)\/?$/;

const stashedParams = (link) => {
  if (typeof window === 'undefined') return {};
  try {
    return JSON.parse(window.sessionStorage.getItem(`${AUTH_LINK_STASH_PREFIX}${link}`)) || {};
  } catch (e) {
    return {};
  }
};

/**
 * The query params of an emailed account link: from the URL (SSR, or where
 * storage was unavailable) or from the stash.
 *
 * @param {string} search
 * @param {'reset-password'|'verify-email'} link
 * @returns {Record<string, any>} parsed like `parse` from urlHelpers
 */
export const authLinkParamsFrom = (search, link) => ({ ...stashedParams(link), ...parse(search) });

/**
 * The apps' counterpart of the head script: a deep link opens the page through
 * the hash router, so the params are stashed before navigating there — the
 * tracked location (screen_view, Pixel) never carries them.
 *
 * @param {string} pathname
 * @param {string} search
 * @returns {string} the search without the stashed params; unchanged for other
 *   paths or when storage is unavailable
 */
export const stashAuthLinkParams = (pathname, search) => {
  const match = pathname.match(AUTH_LINK_PATH);
  if (!match) return search;
  const params = new URLSearchParams(search);
  const stash = {};
  AUTH_LINK_PARAMS.filter((name) => params.has(name)).forEach((name) => {
    stash[name] = params.get(name);
    params.delete(name);
  });
  if (Object.keys(stash).length === 0) return search;
  try {
    window.sessionStorage.setItem(`${AUTH_LINK_STASH_PREFIX}${match[1]}`, JSON.stringify(stash));
  } catch (e) {
    return search;
  }
  const rest = params.toString();
  return rest ? `?${rest}` : '';
};
